export default {
  zh: {
    previous: '上一页',
    next: '下一页'
  },
  en: {
    previous: 'Previous',
    next: 'Next'
  }
}



// WEBPACK FOOTER //
// ./src/components/pager/lang.js